import React, {useContext, useEffect, useState} from 'react';
import {ThemeContext} from 'styled-components';
import {BreakpointSizes} from './responsive-image';

interface MobileViewConditionalRendererProps {
  children: React.ReactNode;
  hideWhenMobileView?: boolean;
  breakpointSize?: BreakpointSizes;
}

const MobileViewConditionalRenderer: React.FC<MobileViewConditionalRendererProps> =
  ({children, hideWhenMobileView, breakpointSize}) => {
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
    const {Breakpoints} = useContext(ThemeContext).internal;

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const shouldHide =
      hideWhenMobileView && windowWidth < (breakpointSize ?? Breakpoints.b560);

    return !shouldHide ? <>{children}</> : null;
  };

export {MobileViewConditionalRenderer};
